import { render } from "./nest_selected_part.vue?vue&type=template&id=5084d4e8"
import script from "./nest_selected_part.vue?vue&type=script&lang=js"
export * from "./nest_selected_part.vue?vue&type=script&lang=js"

import "./nest_selected_part.vue?vue&type=style&index=0&id=5084d4e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__